import { useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';

export default function SurveyEditRedirect() {
  const navigate = useNavigate();
  const { surveyId } = useParams();
  const location = useLocation();

  useEffect(() => {
    const search = new URLSearchParams(location.search);
    if (surveyId) {
      search.set('surveyId', surveyId);
    }
    navigate(`/survey/start?${search.toString()}`, { replace: true });
  }, [navigate, surveyId, location.search]);

  return null;
}
